module.exports = __webpack_public_path__ + "r-v3/img/color_on.ee00ad53.svg";